export enum CJStepsEnum {
    Journey = 'journey',
    Info = 'info',
    BudgetLimit = 'budgetLimit',
}

export enum CJVisualizationUnlockConditionTypeEnum {
    PassSelectedStep = 1,
    CJCondition = 2,
    DateTime = 3,
}

export enum CJVisualizationDueDateTypeEnum {
    DynamicDate = 1,
    Duration = 2,
}

export enum CJVisualizationProgressTypeEnum {
    Amount = 'WfMoney',
    Count = 'WfCount',
}

export enum CJDraftBannerVariantEnum {
    Restored = 'restored',
    NotActual = 'notActual',
}
